import React from 'react';
import { FormattedMessage } from 'react-intl';
import { compose } from 'ramda';
import { withHandlers } from 'recompose';
import PropTypes from 'prop-types';

import Text from 'app/components/layout/Text.styled';
import S from 'app/features/footer/components/Footer.styled';
import withLocale from 'app/features/localization/enhancers/withLocale';
import localizeLink from 'app/features/localization/localizeLink';
import { TERMS_URL } from 'app/router/constants/externalUrls';
import connect from 'app/libs/connect';
import { termsOfServiceSelected } from 'app/features/footer/actions';

const UI = ({ onClick, locale }) => (
  <Text
    as={S.FooterLink}
    size="l"
    type="semibold"
    href={localizeLink(TERMS_URL, locale)}
    target="_blank"
    data-t="footer-tos"
    onClick={onClick}
  >
    <FormattedMessage id="footer_tos" />
  </Text>
);

UI.propTypes = {
  onClick: PropTypes.func.isRequired,
  locale: PropTypes.string,
};

UI.defaultProps = {
  locale: '',
};

const onClick =
  ({ termsOfServiceSelected }) =>
  () => {
    termsOfServiceSelected();
  };

const TermsOfServiceLink = compose(
  connect(null, { termsOfServiceSelected }),
  withHandlers({ onClick }),
  withLocale,
)(UI);

export { UI, onClick };

export default TermsOfServiceLink;
